import React from 'react';
import { motion } from 'framer-motion';
import './Home.css';
import ImageComponent from '../components/ImageComponent';
import IconComponent from '../components/IconComponent';
import ScrollAnimation from '../components/ScrollAnimation';
import heroImage from '../assets/images/project-showcase.png';
import moneyIcon from '../assets/images/money.png';

import painPoint1 from '../assets/images/pain-point-1.jpg';
import painPoint2 from '../assets/images/pain-point-2.jpg';
import painPoint3 from '../assets/images/pain-point-3.jpg';
import painPoint4 from '../assets/images/pain-point-4.jpg';
import solution1 from '../assets/images/solution-1.jpg';
import solution2 from '../assets/images/solution-2.jpg';
import solution3 from '../assets/images/solution-3.jpg';
import solution4 from '../assets/images/solution-4.jpg';

import case1 from '../assets/images/case-1.png';
import case2 from '../assets/images/case-2.png';
import case3 from '../assets/images/case-3.png';

import tool1 from '../assets/images/tool-1.jpg';
import tool2 from '../assets/images/tool-2.jpg';
import { addForm } from '../api/gwform.js';
import { message } from 'antd';

const Home = () => {
  return (
    <div className="home">
      {/* 核心价值区 (Hero Section) */}
      <motion.section
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            数智赋能工程，管控尽在掌握
          </motion.h1>
          <motion.p
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            依托自主研发的"工程数智管控平台"，打通项目、合同、流程与资金，为您的工程建设提供全周期、一体化、数据驱动的解决方案。
          </motion.p>
          <motion.div
            className="hero-buttons"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <button className="primary-button">预约产品演示</button>
            <button className="secondary-button">查看成功案例</button>
          </motion.div>
          <motion.div
            className="hero-visual"
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            <ImageComponent src={heroImage} alt="工程数智管控平台" className="hero-image" />
          </motion.div>
        </div>
      </motion.section>

      {/* 客户痛点区 (Pain Points) */}
      <motion.section
        className="pain-points"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            您的工程项目是否也面临这些"失控"难题？
          </motion.h2>
          <div className="pain-points-grid">
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="pain-point-card">
                <div className="pain-point-icon">
                  <IconComponent icon="schedule" size={48} color="#0052D9" />
                </div>
                <h3>进度黑盒</h3>
                <p>项目节点多，责任不清，项目进度靠"猜"，延期风险高？</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="pain-point-card">
                <div className="pain-point-icon">
                  <img style={{ width: "48px" }} src={moneyIcon} alt="成本超支" />
                  {/* <IconComponent icon="cost" size={48} color="#0052D9" /> */}
                </div>
                <h3>成本超支</h3>
                <p>资金支付随意，成本易超支，多项目核算滞后且混乱？</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="pain-point-card">
                <div className="pain-point-icon">
                  <IconComponent icon="contract" size={48} color="#0052D9" />
                </div>
                <h3>合同混乱</h3>
                <p>合同履约风险高，变更频繁，纸质文档管理查找困难？</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <div className="pain-point-card">
                <div className="pain-point-icon">
                  <IconComponent icon="process" size={48} color="#0052D9" />
                </div>
                <h3>流程低效</h3>
                <p>审批流转靠线下，数据孤岛严重，跨部门协同效率低下？</p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* 解决方案 (Product Focus) */}
      <motion.section
        className="solutions"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            星晟工程管控系统：项目全周期一站式解决方案
          </motion.h2>
          <div className="solutions-grid">
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="solution-item">
                <div className="solution-icon">
                  <IconComponent icon="project" size={60} color="#0052D9" />
                </div>
                <div className="solution-content">
                  <h3>项目一体化管理</h3>
                  <p>从立项到竣工，打通进度、质量、安全、资料等环节，实现全周期、全要素的精细化管控。</p>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="solution-item">
                <div className="solution-icon">
                  <IconComponent icon="contractRisk" size={60} color="#0052D9" />
                </div>
                <div className="solution-content">
                  <h3>智能合同风控</h3>
                  <p>合同全生命周期在线管理，关键节点、收付款项自动预警，规避履约风险。</p>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="solution-item">
                <div className="solution-icon">
                  <IconComponent icon="dashboard" size={60} color="#0052D9" />
                </div>
                <div className="solution-content">
                  <h3>实时资金看板</h3>
                  <p>投资、支付、回款数据实时联动，动态掌握项目资金流，辅助精准决策。</p>
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <div className="solution-item">
                <div className="solution-icon">
                  <IconComponent icon="approval" size={60} color="#0052D9" />
                </div>
                <div className="solution-content">
                  <h3>自动化流程审批</h3>
                  <p>自定义电子审批流，告别纸质单据，让数据多跑路，实现高效、合规的在线协同。</p>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="text-center">
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <a href="/product" className="link-button">了解产品全部功能 →</a>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* 成功案例区 (Social Proof) */}
      <motion.section
        className="case-studies"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            他们选择星晟，实现了精细化管控
          </motion.h2>
          <div className="cases-grid">
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="case-card">
                <ImageComponent src={case1} alt="某大型基建集团" className="case-image" />
                <h3>某大型基建集团</h3>
                <p>"成果：项目审批效率提升40%，成本核算周期由月缩短至周。"</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="case-card">
                <ImageComponent src={case2} alt="知名房地产开发商" className="case-image" />
                <h3>知名房地产开发商</h3>
                <p>"成果：合同履约风险降低30%，实现了多项目资金的统一穿透式管理。"</p>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="case-card">
                <ImageComponent src={case3} alt="某市政工程项目" className="case-image" />
                <h3>某市政工程项目</h3>
                <p>"成果：项目进度100%在线透明，数据上报及时率提升至98%。"</p>
              </div>
            </motion.div>
          </div>
          <div className="text-center">
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <button className="primary-button">查看更多成功案例</button>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* 智能工具区 (Value-Add Tools) */}
      <motion.section
        className="tools"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "0px 0px -100px 0px" }}
        transition={{ duration: 0.8 }}
      >
        <div className="container">
          <motion.h2
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            源自工程领域的专业AI与工具库
          </motion.h2>
          <div className="tools-grid">
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <div className="tool-card">
                <div className="tool-icon">
                  <IconComponent icon="ai" size={60} color="#0052D9" />
                </div>
                <h3>您的 24/7 AI 工程顾问</h3>
                <p>基于海量法规和行业数据，即时解答您的专业问题。</p>
                {/* <div className="input-placeholder">
                  [ 试试提问："最新版工程建设监理费标准是什么？" ]
                </div> */}
                <a href="/ai-qa" className="link-button">立即免费提问 →</a>
              </div>
            </motion.div>
            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <div className="tool-card">
                <div className="tool-icon">
                  <IconComponent icon="calculator" size={60} color="#0052D9" />
                </div>
                <h3>常用工程费用测算</h3>
                <p>招投标费、设计费、监理费、项目管理费...一键估算。</p>
                <a href="/calculation-library" className="link-button">浏览所有工具 →</a>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default Home;